import { render, staticRenderFns } from "./ActivityConfigDetailPanel.vue?vue&type=template&id=63fec99e&scoped=true"
import script from "./ActivityConfigDetailPanel.vue?vue&type=script&lang=js"
export * from "./ActivityConfigDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./ActivityConfigDetailPanel.vue?vue&type=style&index=0&id=63fec99e&prod&scoped=true&lang=css"
import style1 from "./ActivityConfigDetailPanel.vue?vue&type=style&index=1&id=63fec99e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fec99e",
  null
  
)

export default component.exports